import { OdqDateTime } from 'app/shared/model/odq-datetime.model';
import { IMemberResidence, MemberResidenceToAdd, MemberResidenceToChange } from './models/member-residence.model';

export class LoadMemberResidences {
  constructor(public memberId: string) { }
  static readonly type = '[MemberResidences] LoadMemberResidences';
}
export class LoadMemberResidencesSuccess {
  static readonly type = '[MemberResidences] LoadMemberResidencesSuccess';
  constructor(public data: any[]) { }
}
export class LoadMemberResidencesFailure {
  static readonly type = '[MemberResidences] LoadMemberResidencesFailure';
  constructor(public error: any) { }
}

export class AddMemberResidence {
  constructor(public memberId: string, public residence: MemberResidenceToAdd) { }
  static readonly type = '[MemberResidences] AddMemberResidence';
}
export class AddMemberResidenceSuccess {
  static readonly type = '[MemberResidences] AddMemberResidenceSuccess';
  constructor(public memberId: string, public residenceId: string, public residence: IMemberResidence) { }
}
export class AddMemberResidenceFailure {
  static readonly type = '[MemberResidences] AddMemberResidenceFailure';
  constructor(public error: any) { }
}

export class CorrectMemberResidence {
  constructor(public memberId: string, public residence: MemberResidenceToChange) { }
  static readonly type = '[MemberResidences] CorrectMemberResidence';
}
export class CorrectMemberResidenceSuccess {
  static readonly type = '[MemberResidences] CorrectMemberResidenceSuccess';
  constructor(public memberId: string, public residence: MemberResidenceToChange) { }
}
export class CorrectMemberResidenceFailure {
  static readonly type = '[MemberResidences] CorrectMemberResidenceFailure';
  constructor(public error: any) { }
}

export class CancelMemberResidenceChange {
  constructor(public memberId: string, public residenceId: string, public effectiveDate: OdqDateTime,
    public confirmDeleteDomicileProfessionel?: boolean, public domicileProfessionelToDeleteId?: string) { }
  static readonly type = '[MemberResidences] CancelMemberResidenceChange';
}
export class CancelMemberResidenceChangeSuccess {
  static readonly type = '[MemberResidences] CancelMemberResidenceChangeSuccess';
  constructor(public residenceId: string) { }
}
export class CancelMemberResidenceChangeFailure {
  static readonly type = '[MemberResidences] CancelMemberResidenceChangeFailure';
  constructor(public error: any) { }
}
